import Cookies from 'js-cookie';

const ACCESS_TOKEN_COOKIE = 'stytch_session_jwt';
const REFRESH_TOKEN_COOKIE = 'refresh_token';

// Token durations in seconds
export const TOKEN_DURATIONS = {
  ACCESS_TOKEN: 3600, // 1 hour
  REFRESH_TOKEN: 604800, // 7 days
} as const;

const COOKIE_OPTIONS = {
  secure: true,
  sameSite: 'strict' as const,
  expires: 7, // 7 days default
  path: '/',
} as const;

export const getAccessToken = (): string | undefined => {
  return Cookies.get(ACCESS_TOKEN_COOKIE);
};

export const getRefreshToken = (): string | undefined => {
  return Cookies.get(REFRESH_TOKEN_COOKIE);
};

export const setAccessToken = (token: string, expiresIn: number): void => {
  Cookies.set(ACCESS_TOKEN_COOKIE, token, {
    ...COOKIE_OPTIONS,
    expires: expiresIn / (24 * 60 * 60), // Convert seconds to days
  });
};

export const setRefreshToken = (token: string, expiresIn: number): void => {
  Cookies.set(REFRESH_TOKEN_COOKIE, token, {
    ...COOKIE_OPTIONS,
    expires: expiresIn / (24 * 60 * 60), // Convert seconds to days
  });
};

export const clearTokens = (): void => {
  Cookies.remove(ACCESS_TOKEN_COOKIE);
  Cookies.remove(REFRESH_TOKEN_COOKIE);
};
